import { Dialog } from "@blueprintjs/core";
import * as React from "react";
import styled from "styled-components";
import { ITuteurSelectorProps, TuteurSelector } from "../..";
import { useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";

const StyledDialog = styled(Dialog)`
  width: 1100px;
  height: auto;
  background-color: white;
`;

export interface ITuteurSelectorDialogProps extends ITuteurSelectorProps {
  onClosed: (selectedTuteurIds?: number[]) => void;
  selectorDialogOpen: boolean;
}

export const TuteurSelectorDialog: React.FunctionComponent<ITuteurSelectorDialogProps> = ({
  onClosed,
  selectorDialogOpen,
  ...otherProps
}) => {
  const { t } = useTl();

  return (
    <StyledDialog
      title={t(ETLCodes.SearchTuteurs)}
      isOpen={selectorDialogOpen}
      enforceFocus={false}
      onClose={() => onClosed(null)}
    >
      <TuteurSelector {...otherProps} />
    </StyledDialog>
  );
};
